/**
 * Componente para renderizar una sección de firmas en cualquier PDF
 * @param {*} firmas Lista de firmas. Cada elemento puede ser:
 *                    - string: se muestra como etiqueta bajo la línea
 *                    - { titulo, nombre }: muestra el nombre sobre la línea (si existe)
 *                      y el título debajo. Si nombre viene vacío, sólo queda la línea
 *                      para firmar a mano.
 * @returns
 */
export const BloqueFirmasPdf = (firmas = []) => {
  if (!firmas || firmas.length === 0) return {};

  return {
    margin: [0, 30, 0, 0],
    columns: firmas.map((entrada) => {
      const esObjeto = entrada && typeof entrada === 'object';
      const titulo = esObjeto ? (entrada.titulo || '') : entrada;
      const nombre = esObjeto ? (entrada.nombre || '') : '';
      const imagenFirma = esObjeto ? (entrada.firma || null) : null;

      const filaImagen = imagenFirma
        ? [{ image: imagenFirma, width: 110, height: 45, alignment: 'center', border: [false, false, false, false], margin: [0, 0, 0, 0] }]
        : [{ text: '', border: [false, false, false, false], margin: [0, 45, 0, 0] }];

      return {
        width: '*',
        margin: [40, 0, 40, 0],
        table: {
          widths: ['*'],
          body: [
            filaImagen,
            [{ text: '', border: [false, false, false, true] }],
            [{ text: titulo ? `${titulo}\n${nombre}` : nombre, border: [false, false, false, false], alignment: 'center', style: 'subheader', margin: [0, 5, 0, 0] }],
          ]
        }
      };
    })
  };
};